import React, { Component } from "react";
import { Col, Row, Form, Tooltip } from "react-bootstrap";
import FormField from "../../../Components/Shared/FormField";
import SelectField from "../../../Components/Shared/SelectField";
import RadioGroup from "../../../Components/Shared/RadioGroup";
import DatePickerField from "../../../Components/Shared/DatePickerField";
import TextAreaField from "../../../Components/Shared/TextAreaField";
import Buttons from "../../../Components/Shared/Button";
import moment from "moment";
import { PostJobValidator } from "../../../Utilities/PostJobValidation";
import { postJob } from "../../../Redux/Jobs/Action";
import { connect } from "react-redux";
import {
  getCountry,
  getDraftJobsCount,
  getGroups,
  getIndustry,
  getStateByCountry,
  getUserDetails,
} from "../../../Services/GetFields";
import { toast } from "react-toastify";
import help_icon from "../../../assests/img/help_icon.png";
import { post } from "../../../Services/AxiosService";
import { getProfanitiesWords } from "../../../Services/ResumeService";
import { API_URL } from "../../../Utilities/Helper";
import postJobInitialState from "./postJobInitialState";

class PostJobForm extends Component {
  state = { ...postJobInitialState };

  getProfanitiesWordsForValidate() {
    getProfanitiesWords()
      .then((res) => {
        this.setState({ ProfanitiesWords: res.data.response });
        // Update validator with profanities words
        this.validator.profanitiesWords = res.data.response;
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // DatePicker settings

  componentDidMount = () => {
    this.getProfanitiesWordsForValidate();
    getUserDetails()
      .then((res) => {
        let response = res.response;
        let industryArray = res.response.industries;

        let industry = [];
        for (let i = 0; i < industryArray.length; i++) {
          industry.push({ IndustryId: industryArray[i].industryId });
        }

        const countryText = response.countryId;
        getStateByCountry(countryText)
          .then((res) => {
            const result = JSON.parse(res.response);
            this.setState({ countryStateList: result });
          })
          .catch((err) => {
            console.log(err);
          });

        this.setState({
          contactName: response.firstName + " " + response.lastName,
          telephone: response.phoneNumber,
          contactEmail: response.email,
          country: response.countryId,
          countryState:
            response.stateId !== 0 ? response.stateId : response.stateName,
          stateName: response.stateName,
          city: response.city,
          // group: response.groupId,
          // groupName: response.groupName,
          // subcategory: response.groupCategoryId,
          // groupCategoryName: response.groupCategoryName,
          // organizationName: response.groupName,
          // position: response.position ? response.position : "",
          company: response.companyName,
          // industry: industry,
          // groupId: response.groupId
          resultState: false,
        });
      })
      .catch((err) => {
        console.log(err);
      });

    getCountry()
      .then((res) => {
        const result = JSON.parse(res.response);
        this.setState({ countryList: result });
      })
      .catch((err) => {
        console.log(err);
      });

    getIndustry()
      .then((res) => {
        const result = JSON.parse(res.response);
        let industryArray = [];
        for (let i = 0; i < result.length; i++) {
          industryArray.push({
            label: result[i].industryName,
            value: result[i].industryId,
          });
        }
        this.setState({ industryList: industryArray });
      })
      .catch((err) => {
        console.log(err);
      });

    getGroups()
      .then((res) => {
        const result = JSON.parse(res.response);
        result.push({ groupId: "all", groupName: "All Groups" });
        this.setState({ groupList: result });
      })
      .catch((err) => {
        console.log(err);
      });

    getDraftJobsCount()
      .then((res) => {
        const result = JSON.parse(res.response);
        this.setState({ draftsCount: result });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  constructor(props) {
    super(props);
    this.textInput = React.createRef();
    this.focusTextInput = this.focusTextInput.bind(this);
    this.minDate = new moment(props.minDate);
    this.maxDate = new moment(props.maxDate);
    this.state = {
      startDate: props.minDate,
      endDate: props.maxDate,
      selectedValue: "Nothing selected",
    };
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);

    // Initialize validator
    this.validator = new PostJobValidator();
  }

  focusTextInput() {
    // Add null check and use correct focus method for DatePicker
    if (this.textInput && this.textInput.current) {
      // DatePicker component uses focus() method, not setFocus()
      if (this.textInput.current.focus) {
        this.textInput.current.focus();
      } else if (this.textInput.current.setFocus) {
        this.textInput.current.setFocus();
      }
    }
  }

  buttonChange = (event) => {
    const value = event.target.value;
    if (value) {
      this.setState({ jobTypeId: value, jobTypeIdError: false });
    }
  };

  handleCountryChange = (e) => {
    this.setState({ countryStateList: [] });
    let countryValue = 0;
    countryValue = e.target.value;
    var index = e.nativeEvent.target.selectedIndex;
    const countryText = e.nativeEvent.target[index].text;
    this.setState({ country: countryValue, countryState: "" });
    if (countryText === "Other")
      this.setState({ showStateTextBox: true, stateName: "" });
    else this.setState({ showStateTextBox: false });
    if (countryValue === "0") {
      this.setState({ countryError: true, country: e.target.value });
    } else {
      this.setState({ countryError: false, country: e.target.value });
      getStateByCountry(countryValue)
        .then((res) => {
          const result = JSON.parse(res.response);
          this.setState({ countryStateList: result });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  handleGroupChange = (e) => {
    const groupValue = [];
    let ids = [];
    if (e.target.value === "0") {
      this.setState({ groupError: true, group: undefined });
    }
    if (e.target.value === "all") {
      for (let i = 0; i < this.state.groupList.length - 1; i++) {
        ids.push(this.state.groupList[i].groupId);
      }
      this.setState({ group: ids, groupError: false });
    } else {
      groupValue.push(parseInt(e.target.value));
      this.setState({ group: groupValue, groupError: false });
    }
  };

  handleIndustryChange = (event) => {
    const { value } = event.target;
    const selectedIndustry = this.state.industryList.find(
      (item) => item.value == value
    );
    const industryName = selectedIndustry ? selectedIndustry.label : "";

    this.setState({
      industry: value === "0" ? undefined : value,
      industryError: value === "0" || value === "",
      industryNameForActivity: industryName,
    });
  };

  handleDateChange(date) {
    var selectedDate = new Date(date);
    var todayDate = new Date();
    if (selectedDate > todayDate) {
      this.setState(
        { startDate: date, startDateError: false, endDate: "" },
        () => {
          this.setState({ disablePost: true });
        }
      );
    } else {
      this.setState({ startDate: date, startDateError: false }, () => {
        this.setState({ disablePost: false });
      });
    }
  }

  handleEndDateChange(date) {
    this.setState({ endDate: date, endDateError: false });
  }

  // custom select settings
  handleSelectChange = (selectedValue) => {
    this.setState({
      selectedValue: selectedValue,
    });
  };

  handleChange = (key) => (value) => {
    // Set the value in state
    this.setState({ [key]: value });

    // Clear basic validation errors when user starts typing
    const clearErrorMap = {
      company: this.state.jobTypeId !== "3" ? "companyError" : null,
      city: "cityError",
      stateName: "countryStateError",
      contactName: this.state.jobTypeId !== "3" ? "contactNameError" : null,
      position: "positionError",
      contactEmail: this.state.jobTypeId !== "3" ? "emailError" : null,
      address1: "addressError",
      telephone: "phoneValidError",
      zip: "zipValidError",
      postLink: this.state.jobTypeId === "3" ? "linkError" : null,
      description: this.state.jobTypeId !== "3" ? "descriptionError" : null,
    };

    const errorField = clearErrorMap[key];
    if (errorField) {
      // Clear error when user starts typing (except for empty values)
      if (value !== "" || key === "telephone" || key === "zip") {
        this.setState({ [errorField]: false });
      } else {
        // Set error for required fields when empty
        this.setState({ [errorField]: true });
      }
    }

    // Special handling for postLink in job type 3
    if (key === "postLink" && this.state.jobTypeId === "3") {
      this.setState({
        linkError: value === "",
        linkValidError: false,
      });
    }

    // Special handling for description field to also update the description value
    if (key === "description") {
      this.setState({ description: value });
    }
  };

  handleOnBlur = (key) => (value) => {
    this.setState({ [key]: value });

    // Use the validator helper
    const { updates } = this.validator.validateField(key, value, this.state);
    this.setState(updates);
  };

  setOptions = (e) => {
    const { name, value } = e.target;

    switch (name) {
      case "telecommute":
        this.setState({ telecommute: value });
        break;

      case "travel":
        this.setState({
          travelRequired: value || undefined,
          travelError: value === "",
        });
        break;

      case "joblength":
        this.setState({
          jobLength: value || undefined,
          joblengthError: value === "",
        });
        break;

      case "countryState":
        this.setState({
          countryState: value === "" || value === "0" ? 0 : value,
          countryStateError: value === "" || value === "0",
        });
        break;

      default:
        break;
    }
  };

  onChangeGroup = (e) => {
    const { name, value } = e.target;

    switch (name) {
      case "group":
        this.setState({
          groupError: value === "" || value === "0",
        });
        break;

      case "industry":
        this.setState({
          industryError: value === "",
        });
        break;

      case "joblength":
        if (this.state.jobTypeId !== "3") {
          this.setState({
            joblengthError: value === "",
          });
        }
        break;

      default:
        break;
    }
  };

  setRefresh = () => {
    this.setState({ disablePost: false, disableDraft: false });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    let jobPostType = "";
    if (event.target.innerText === "Post job") {
      jobPostType = "Published Jobs";
    } else {
      jobPostType = "Draft Jobs";
    }

    const {
      jobTypeId,
      description,
      position,
      payRate,
      contactName,
      contactEmail,
      company,
      telephone,
      telecommute,
      pQualification,
      jobLength,
      travelRequired,
      responsibilities,
      mQualification,
      policy,
      postLink,
      startDate,
      endDate,
      address1,
      address2,
      country,
      countryState,
      city,
      zip,
      group,
      stateName,
      showStateTextBox,
      industry,
      industryNameForActivity,
    } = this.state;

    // Create a promise to handle validation with state updates
    const validateForm = (formData) => {
      return new Promise((resolve) => {
        const { isValid, stateUpdates } = this.validator.validate(
          formData,
          this.state
        );

        // Apply state updates and resolve with validation result
        this.setState(stateUpdates, () => {
          resolve(isValid);
        });
      });
    };

    let result = false;
    if (!showStateTextBox) {
      const formData = {
        jobTypeId,
        startDate,
        endDate,
        company,
        group,
        address1,
        country,
        countryState,
        city,
        contactName,
        contactEmail,
        position,
        description,
        travelRequired,
        telephone,
        zip,
        jobLength,
        industry,
        postLink,
        payRate,
        showStateTextBox: this.state.showStateTextBox,
      };
      result = await validateForm(formData);
    } else {
      const formData = {
        jobTypeId,
        startDate,
        endDate,
        company,
        group,
        address1,
        country,
        countryState: stateName,
        city,
        contactName,
        contactEmail,
        position,
        description,
        travelRequired,
        telephone,
        zip,
        jobLength,
        industry,
        postLink,
        payRate,
        showStateTextBox: this.state.showStateTextBox,
      };
      result = await validateForm(formData);
    }

    if (result) {
      var start = moment(startDate).format("YYYY/MM/DD");

      var end =
        moment(endDate).format("YYYY/MM/DD") +
        " " +
        moment(new Date()).format("hh:mm:ss a");
      var UTCJobEndDate = new Date(end).toISOString();

      let payload = {
        JobTypeId: jobTypeId,
        JobDescription: description,
        JobStatus: jobPostType,
        IndustryId: industry,
        PositionTitle: position ? position.trim() : "",
        PayRate: payRate,
        ContactName: contactName,
        ContactEmail: contactEmail,
        CompanyName: company,
        ContactPhone: telephone,
        Telecommute: telecommute,
        PreferredQualification: pQualification,
        JobLength: jobLength,
        TravelRequired: travelRequired,
        PositionResponsibilities: responsibilities,
        MinimumQualification: mQualification,
        EmploymentPolicy: policy,
        JobPostingLink: postLink,
        JobStartDate: start,
        JobEndDate: end,
        UTCJobEndDate: UTCJobEndDate,
        AddressLine1: address1,
        AddressLine2: address2,
        City: city,
        StateId: showStateTextBox ? 0 : countryState,
        StateName: showStateTextBox ? stateName : null,
        CountryId: country,
        ZipCode: zip,
        GroupIds: group,
        IndustryName: industryNameForActivity,
        CurrentDate: moment(new Date()).format("YYYY/MM/DD"),
      };

      const toastId = "custom_toast";
      this.setState({ disablePost: true, disableDraft: true });
      post(API_URL + `job/createjob`, payload)
        .then((response) => {
          this.setState({ disablePost: false, disableDraft: false });
          if (response.status === 200) {
            // Clear job posting payment data on successful job creation
            localStorage.removeItem("jobPostingPaymentCompleted");

            setTimeout(this.setRefresh, 7000);
            toast.success(response.data.response, { toastId: toastId });
            window.location.href = `${process.env.PUBLIC_URL}/#/jobslist`;
          }
        })
        .catch(function (error) {
          this.setState({ disablePost: false, disableDraft: false });
          if (error.response) {
            toast.error(error.response);
            console.log(error.response);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log("Error", error.message);
          }
          console.log(error);
        });
    } else {
      // Validation failed - error messages should now be visible in the form
      return;
    }
  };

  renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Employer should have a 60 day maximum from start date to end date.
    </Tooltip>
  );

  render() {
    return (
      <Form noValidate>
        <Row>
          <Col md={12}>
            <div className="dashboard-box activity dashboard-col-bg post-job-form">
              <p className="text-danger mb-3 text-right small">
                All fields marked with * are required.
              </p>
              <Row>
                <RadioGroup
                  name="radio"
                  label="Job Poster: *"
                  selectedValue={this.state.jobTypeId}
                  onChange={this.buttonChange}
                  error={this.state.jobTypeIdError}
                  errorMessage="Job Poster type is required"
                  options={[
                    { value: "1", label: "Hiring Manager" },
                    {
                      value: "2",
                      label: "Company Employee",
                      sublabel: "(Not Hiring manager)",
                    },
                    { value: "3", label: "Unaffiliated" },
                  ]}
                  colProps={{ md: 12 }}
                />
              </Row>
              <Row>
                <DatePickerField
                  selected={this.state.startDate}
                  onChange={this.handleDateChange}
                  minDate={this.minDate}
                  placeholder="Job post start date *"
                  error={this.state.startDateError}
                  errorMessage="Start Date is required"
                  colProps={{ md: 4 }}
                  onCalendarClose={() => {
                    if (this.state.startDate) this.focusTextInput();
                  }}
                />
                <DatePickerField
                  selected={this.state.endDate}
                  onChange={this.handleEndDateChange}
                  minDate={this.state.startDate}
                  maxDate={
                    this.state.startDate &&
                    new Date(
                      new Date(this.state.startDate).setDate(
                        new Date(this.state.startDate).getDate() + 60
                      )
                    )
                  }
                  placeholder="Job post end date *"
                  error={this.state.endDateError}
                  errorMessage="End Date is required"
                  colProps={{ md: 4, className: "position-relative" }}
                  tooltip="Job posting end date cannot exceed 60 days from start date"
                  tooltipIcon={help_icon}
                  ref={this.textInput}
                />
                <FormField
                  name="company"
                  value={this.state.company}
                  placeholder={
                    this.state.jobTypeId !== "3" ? "Company *" : "Company *"
                  }
                  maxLength={30}
                  onChange={this.handleChange("company")}
                  onBlur={this.handleOnBlur("company")}
                  error={
                    this.state.companyError && this.state.jobTypeId !== "3"
                  }
                  errorMessage="Company is required"
                  validationErrors={[
                    {
                      condition:
                        this.state.companyNameValidError &&
                        !this.state.companyError,
                      message: "Enter valid company name",
                    },
                    {
                      condition: this.state.validCompanyContentError,
                      message: "Disallowed Content",
                    },
                  ]}
                  colProps={{ md: 4 }}
                />
              </Row>
              <Row>
                <SelectField
                  name="group"
                  value={this.state.group}
                  onChange={this.handleGroupChange}
                  errors={{ groupError: this.state.groupError }}
                  validationRules={{ groupError: this.state.groupError }}
                  options={[
                    { value: "0", label: "Select Group *" },
                    ...(this.state.groupList || []).map((item) => ({
                      value: item.groupId,
                      label: item.groupName,
                    })),
                  ]}
                  colProps={{ className: "dd" }}
                />
                <FormField
                  name="address1"
                  value={this.state.address1}
                  placeholder="Address line 1 *"
                  maxLength={150}
                  onChange={this.handleChange("address1")}
                  onBlur={this.handleOnBlur("address1")}
                  error={this.state.addressError}
                  errorMessage="Address is required"
                  validationErrors={[
                    {
                      condition: this.state.validAddress1ContentError,
                      message: "Disallowed Content",
                    },
                  ]}
                />
                <FormField
                  name="address2"
                  value={this.state.address2}
                  placeholder="Address line 2"
                  maxLength={150}
                  onChange={this.handleChange("address2")}
                  onBlur={this.handleOnBlur("address2")}
                  validationErrors={[
                    {
                      condition: this.state.validAddress2ContentError,
                      message: "Disallowed Content",
                    },
                  ]}
                />
              </Row>
              <Row>
                <SelectField
                  name="country"
                  value={this.state.country}
                  onChange={this.handleCountryChange}
                  errors={{
                    countryError:
                      this.state.countryError && this.state.jobTypeId !== "3",
                  }}
                  validationRules={{
                    countryError:
                      this.state.countryError && this.state.jobTypeId !== "3",
                  }}
                  options={[
                    {
                      value: "0",
                      label:
                        this.state.jobTypeId !== "3"
                          ? "Select Country *"
                          : "Select Country *",
                    },
                    ...(this.state.countryList || []).map((item) => ({
                      value: item.countryId,
                      label: item.countryName,
                    })),
                  ]}
                  colProps={{
                    md: 4,
                    className: this.state.jobTypeId !== "3" ? "dd" : "dd",
                  }}
                />
                {!this.state.showStateTextBox ? (
                  <SelectField
                    name="countryState"
                    value={this.state.countryState}
                    onChange={this.setOptions}
                    errors={{
                      countryStateError:
                        this.state.countryStateError &&
                        this.state.jobTypeId !== "3",
                    }}
                    validationRules={{
                      countryStateError:
                        this.state.countryStateError &&
                        this.state.jobTypeId !== "3",
                    }}
                    options={[
                      {
                        value: "0",
                        label:
                          this.state.jobTypeId !== "3"
                            ? this.state.country == 2
                              ? "Select Province *"
                              : "Select State *"
                            : this.state.country == 2
                            ? "Select Province *"
                            : "Select State *",
                      },
                      ...(this.state.countryStateList || []).map((item) => ({
                        value: item.stateId,
                        label: item.stateName,
                      })),
                    ]}
                    colProps={{
                      md: 4,
                      className: this.state.jobTypeId !== "3" ? "dd" : "dd",
                    }}
                  />
                ) : (
                  <FormField
                    name="stateName"
                    value={this.state.stateName}
                    placeholder={
                      this.state.jobTypeId !== "3" ? "Country *" : "State *"
                    }
                    maxLength={30}
                    onChange={this.handleChange("stateName")}
                    onBlur={this.handleOnBlur("stateName")}
                    error={
                      this.state.countryStateError &&
                      this.state.jobTypeId !== "3"
                    }
                    errorMessage={
                      this.state.country == 2
                        ? "Province is required"
                        : "State is required"
                    }
                    validationErrors={[
                      {
                        condition:
                          this.state.stateValidError &&
                          !this.state.countryStateError,
                        message: "Enter valid State",
                      },
                      {
                        condition: this.state.validStateContentError,
                        message: "Disallowed Content",
                      },
                    ]}
                    colProps={{
                      md: 4,
                      className: this.state.jobTypeId !== "3" ? "dd" : "dd",
                    }}
                  />
                )}
                <FormField
                  name="city"
                  value={this.state.city}
                  placeholder={
                    this.state.jobTypeId !== "3" ? "City *" : "City *"
                  }
                  maxLength={30}
                  onChange={this.handleChange("city")}
                  onBlur={this.handleOnBlur("city")}
                  error={this.state.cityError && this.state.jobTypeId !== "3"}
                  errorMessage="City is required"
                  validationErrors={[
                    {
                      condition:
                        this.state.cityValidError && !this.state.cityError,
                      message: "Enter valid City",
                    },
                    {
                      condition: this.state.validCityContentError,
                      message: "Disallowed Content",
                    },
                  ]}
                  colProps={{ md: 4 }}
                />
              </Row>

              <Row>
                <FormField
                  name="zip"
                  value={this.state.zip}
                  placeholder="Zip"
                  maxLength={6}
                  onChange={this.handleChange("zip")}
                  onBlur={this.handleOnBlur("zip")}
                  validationErrors={[
                    {
                      condition: this.state.zipValidError,
                      message: "Enter valid ZIP",
                    },
                    {
                      condition: this.state.validZipContentError,
                      message: "Disallowed Content",
                    },
                  ]}
                  colProps={{ md: 4 }}
                />
                <FormField
                  name="contactName"
                  value={this.state.contactName}
                  placeholder={
                    this.state.jobTypeId !== "3"
                      ? "Contact Name *"
                      : "Contact Name *"
                  }
                  maxLength={60}
                  onChange={this.handleChange("contactName")}
                  onBlur={this.handleOnBlur("contactName")}
                  error={
                    this.state.contactNameError && this.state.jobTypeId !== "3"
                  }
                  errorMessage="Contact Name is required"
                  validationErrors={[
                    {
                      condition:
                        this.state.nameValidError &&
                        !this.state.contactNameError,
                      message: "Enter valid Name",
                    },
                    {
                      condition: this.state.validContactContentError,
                      message: "Disallowed Content",
                    },
                  ]}
                  colProps={{ md: 4 }}
                />
                <FormField
                  name="contactEmail"
                  type="email"
                  value={this.state.contactEmail}
                  placeholder={
                    this.state.jobTypeId !== "3"
                      ? "Contact Email *"
                      : "Contact Email *"
                  }
                  maxLength={100}
                  onChange={this.handleChange("contactEmail")}
                  onBlur={this.handleOnBlur("contactEmail")}
                  error={this.state.emailError && this.state.jobTypeId !== "3"}
                  errorMessage="Email is required"
                  validationErrors={[
                    {
                      condition:
                        this.state.emailValidError && !this.state.emailError,
                      message: "Enter valid Email",
                    },
                  ]}
                  colProps={{ md: 4 }}
                />
              </Row>
              <Row>
                <FormField
                  name="telephone"
                  value={this.state.telephone}
                  placeholder="Telephone"
                  maxLength={11}
                  minLength={10}
                  onChange={this.handleChange("telephone")}
                  onBlur={this.handleOnBlur("telephone")}
                  validationErrors={[
                    {
                      condition: this.state.phoneValidError,
                      message: "Enter valid phone number",
                    },
                  ]}
                  colProps={{ md: 4 }}
                />
                <SelectField
                  name="industry"
                  value={this.state.industry}
                  onChange={this.handleIndustryChange}
                  errors={{ industryError: this.state.industryError }}
                  validationRules={{
                    industryError: this.state.industryError,
                  }}
                  options={[
                    { value: "0", label: "Select Industry *" },
                    ...(this.state.industryList || []).map((item) => ({
                      value: item.value,
                      label: item.label,
                    })),
                  ]}
                  colProps={{ md: 4 }}
                />
                <FormField
                  name="position"
                  value={this.state.position}
                  placeholder="Position *"
                  maxLength={50}
                  onChange={this.handleChange("position")}
                  onBlur={this.handleOnBlur("position")}
                  error={this.state.positionError}
                  errorMessage="Position is required"
                  validationErrors={[
                    {
                      condition:
                        this.state.positionValidError &&
                        !this.state.positionError,
                      message: "Enter valid Position",
                    },
                    {
                      condition: this.state.validPositionContentError,
                      message: "Disallowed Content",
                    },
                  ]}
                  colProps={{ md: 4 }}
                />
              </Row>
              <Row>
                <FormField
                  name="payRate"
                  value={this.state.payRate}
                  placeholder="Compensation"
                  maxLength={100}
                  onChange={this.handleChange("payRate")}
                  onBlur={this.handleOnBlur("payRate")}
                  validationErrors={[
                    {
                      condition: this.state.payRateError,
                      message: "Enter valid pay rate",
                    },
                    {
                      condition: this.state.validCompensationContentError,
                      message: "Disallowed Content",
                    },
                  ]}
                  colProps={{ md: 4 }}
                />
                <SelectField
                  name="joblength"
                  value={this.state.jobLength}
                  onChange={this.setOptions}
                  errors={{
                    joblengthError:
                      this.state.joblengthError && this.state.jobTypeId !== "3",
                  }}
                  validationRules={{
                    joblengthError:
                      this.state.joblengthError && this.state.jobTypeId !== "3",
                  }}
                  options={[
                    {
                      value: "",
                      label:
                        this.state.jobTypeId !== "3"
                          ? "Job length *"
                          : "Job length *",
                    },
                    { value: "Permanant", label: "Permanant" },
                    { value: "Contract", label: "Contract" },
                  ]}
                  colProps={{ md: 4 }}
                />
                <SelectField
                  name="travel"
                  value={this.state.travelRequired}
                  onChange={this.setOptions}
                  errors={{
                    travelError:
                      this.state.travelError && this.state.jobTypeId !== "3",
                  }}
                  validationRules={{
                    travelError:
                      this.state.travelError && this.state.jobTypeId !== "3",
                  }}
                  options={[
                    {
                      value: "",
                      label:
                        this.state.jobTypeId !== "3" ? "Travel *" : "Travel *",
                    },
                    { value: "true", label: "Yes" },
                    { value: "false", label: "No" },
                  ]}
                  colProps={{ md: 4 }}
                />
              </Row>

              <Row>
                <SelectField
                  name="telecommute"
                  value={this.state.telecommute}
                  onChange={(e) => {
                    this.onChangeGroup(e);
                    this.setOptions(e);
                  }}
                  options={[
                    { value: "", label: "Telecommute" },
                    { value: "true", label: "Yes" },
                    { value: "false", label: "No" },
                  ]}
                  colProps={{ md: 4 }}
                />
              </Row>
              <Row style={{ marginTop: 16 }}>
                <TextAreaField
                  name="description"
                  value={this.state.description}
                  placeholder={
                    this.state.jobTypeId !== "3"
                      ? "Description *"
                      : "Description *"
                  }
                  onChange={this.handleChange("description")}
                  onBlur={this.handleOnBlur("description")}
                  error={
                    this.state.descriptionError && this.state.jobTypeId !== "3"
                  }
                  errorMessage="Description is required"
                  validationErrors={[
                    {
                      condition: this.state.validDescriptionContentError,
                      message: "Disallowed Content",
                    },
                  ]}
                />
              </Row>
              <Row>
                <FormField
                  name="responsibilities"
                  value={this.state.responsibilities}
                  placeholder="Position responsibilities"
                  onChange={this.handleChange("responsibilities")}
                  onBlur={this.handleOnBlur("responsibilities")}
                  validationErrors={[
                    {
                      condition: this.state.validPositionResContentError,
                      message: "Disallowed Content",
                    },
                  ]}
                  colProps={{ md: 6 }}
                />
                <FormField
                  name="mQualification"
                  value={this.state.mQualification}
                  placeholder="Minimum qualification"
                  maxLength={256}
                  onChange={this.handleChange("mQualification")}
                  onBlur={this.handleOnBlur("mQualification")}
                  validationErrors={[
                    {
                      condition: this.state.validMinimumQualContentError,
                      message: "Disallowed Content",
                    },
                  ]}
                  colProps={{ md: 6 }}
                />
                <FormField
                  name="pQualification"
                  value={this.state.pQualification}
                  placeholder="Preferred qualification"
                  maxLength={256}
                  onChange={this.handleChange("pQualification")}
                  onBlur={this.handleOnBlur("pQualification")}
                  validationErrors={[
                    {
                      condition: this.state.validPreferredQualContentError,
                      message: "Disallowed Content",
                    },
                  ]}
                  colProps={{ md: 6 }}
                />
                <FormField
                  name="policy"
                  value={this.state.policy}
                  placeholder="Employment policy"
                  onChange={this.handleChange("policy")}
                  onBlur={this.handleOnBlur("policy")}
                  validationErrors={[
                    {
                      condition: this.state.validEmpPolicyContentError,
                      message: "Disallowed Content",
                    },
                  ]}
                  colProps={{ md: 6 }}
                />
                {this.state.jobTypeId === "3" && (
                  <FormField
                    name="postLink"
                    value={this.state.postLink}
                    placeholder="Job Posting Link *"
                    maxLength={256}
                    onChange={this.handleChange("postLink")}
                    onBlur={this.handleOnBlur("postLink")}
                    error={this.state.linkError && this.state.jobTypeId === "3"}
                    errorMessage="Post Link is required"
                    validationErrors={[
                      {
                        condition:
                          this.state.linkValidError &&
                          !this.state.linkError &&
                          this.state.jobTypeId === "3",
                        message: "Enter valid post link",
                      },
                      {
                        condition: this.state.validPostLinkContentError,
                        message: "Disallowed Content",
                      },
                    ]}
                    colProps={{ md: 6 }}
                  />
                )}
              </Row>

              {this.state.startDate !== undefined &&
                this.state.startDate > new Date() && (
                  <Row>
                    {" "}
                    <Col>
                      <p className="text-danger ml-3 mt-2 text-left small">
                        You are posting a Job for future date. Click "Save for
                        Later" and job will automatically be posted on{" "}
                        {moment(this.state.startDate).format("MMM DD, Y")}
                      </p>
                    </Col>
                  </Row>
                )}

              <Row>
                <Col className="mt-4 post-job-footer-btns">
                  {/* <Link to={`${process.env.PUBLIC_URL}/jobslist`} className="text-decoration-none"> */}
                  {this.state.disablePost && (
                    <Buttons
                      disabled
                      variant="warning"
                      title="Post job"
                      type="button"
                      size="xs"
                      color="white"
                      onClick={this.handleSubmit}
                    ></Buttons>
                  )}
                  {!this.state.disablePost && (
                    <Buttons
                      variant="warning"
                      title="Post job"
                      type="button"
                      size="xs"
                      color="white"
                      onClick={this.handleSubmit}
                    ></Buttons>
                  )}
                  {/* </Link> */}
                  {/* {this.state.disableDraft && (
                    <Buttons
                      disabled
                      variant="secondary"
                      title="Save for later"
                      onClick={this.handleSubmit}
                      type="button"
                      size="xs"
                      color="white"
                      marginLeft="ml-3"
                    ></Buttons>
                  )}
                  {!this.state.disableDraft && (
                    <Buttons
                      variant="secondary"
                      title="Save for later"
                      onClick={this.handleSubmit}
                      type="button"
                      size="xs"
                      color="white"
                      marginLeft="ml-3"
                    ></Buttons>
                  )} */}
                  <Buttons
                    variant="light"
                    title="Cancel"
                    onClick={() => {
                      window.location.href = `${process.env.PUBLIC_URL}/#/jobslist`;
                    }}
                    type="button"
                    size="xs"
                    color="white"
                    marginLeft="ml-3"
                  ></Buttons>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default connect(null, { postJob })(PostJobForm);
